import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminRoute from "./auth/helper/AdminRoute";
import SuperAdminRoute from "./auth/helper/SuperAdminRoute";
import Login from "./auth/login/Login";
import Signup from "./auth/signup/Signup";
import ManageCategory from "./core/category/ManageCategory";
import ManageCourse from "./core/course/ManageCourse";
import Home from "./core/home/Home";
import Container from "./core/layout/Container";
import Practise from "./core/practise/Practise";
import ManageUsers from "./core/users/ManageUsers";

function Routing() {
  return (
    <Router>
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/practise" element={<Practise />} />
          <Route
            path="/course/manage"
            element={
              <AdminRoute>
                <ManageCourse />
              </AdminRoute>
            }
          />
          <Route
            path="/category/manage"
            element={
              <AdminRoute>
                <ManageCategory />
              </AdminRoute>
            }
          />
          <Route
            path="/users/manage"
            element={
              <SuperAdminRoute>
                <ManageUsers />
              </SuperAdminRoute>
            }
          />
        </Routes>
      </Container>
    </Router>
  );
}

export default Routing;
